import { AddBarCodeFeature, AddBarCodeFeatures } from "@rastreabilidadebrasil/tageditor";
import { Button } from "@mui/material";
import { QrCode } from "@mui/icons-material";
import { useCallback, useState } from "react";

import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";

import { ArrowButtonIcon } from "../../../../../components/common/icons";
import { useTranslation } from "react-i18next";

export default function QRBarcode() {
  const [barCodeFeature, setBarCodeFeature] = useState<AddBarCodeFeatures>();
  const { t } = useTranslation("editor");

  const addQrCode = useCallback(() => {
    barCodeFeature?.add({
      barCodeType: "qrcode",
      barCodeText: "Valor do QRCode",
    });
  }, [barCodeFeature]);
  return (
    <>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>
            {t("QR e Código de Barras")}
            <ArrowButtonIcon onClick={() => undefined} />
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <AddBarCodeFeature featureUpdate={(f) => setBarCodeFeature(f)}>
            <div className="editor-tb-button-container">
              <Button
                className="btn btn-outlined-primary"
                startIcon={<QrCode />}
                variant="outlined"
                component="label"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff4d4";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
                onClick={() => addQrCode()}
              >
                {" "}
                {t("QR e Código de Barras")}
              </Button>
            </div>
          </AddBarCodeFeature>
        </AccordionItemPanel>
      </AccordionItem>
    </>
  );
}
